{
  "title": "لوحة التحكم",
  "greeting": {
    "morning": "صباح الخير",
    "evening": "مساء الخير"
  },
  "subtitle": "{{month}} · {{greeting}} يا {{name}}",
  "newBooking": "حجز جديد",
  "stats": {
    "monthBookings": {
      "label": "حجوزات الشهر",
      "sub": "مؤكدة منذ بداية الشهر"
    },
    "netFees": {
      "label": "صافي رسوم المنشأة",
      "sub": "من رسوم {{fees}} بعد حصص المنسقين"
    },
    "awaiting": {
      "label": "فواتير بانتظار الدفع",
      "oldest": "أقدمها منذ {{n}} أيام"
    },
    "coordinatorDues": {
      "label": "عمولات مستحقة للمنسقين",
      "sub": "لـ {{n}} منسقين · لم تُحوَّل بعد"
    },
    "monthExpenses": {
      "label": "مصروفات الشهر",
      "sub": "{{n}} مصروفاً منذ بداية الشهر"
    },
    "netProfit": {
      "label": "صافي الربح",
      "sub": "صافي الرسوم {{fees}} − المصروفات {{expenses}}"
    }
  },
  "recent": {
    "title": "أحدث الحجوزات",
    "viewAll": "عرض الكل",
    "empty": "لا توجد حجوزات بعد",
    "columns": {
      "reference": "رقم الحجز",
      "customerPartner": "العميل · الشريك",
      "fee": "الرسم",
      "coordinator": "المنسق",
      "status": "الحالة"
    }
  },
  "unpaid": {
    "title": "فواتير بانتظار الدفع",
    "all": "الكل",
    "empty": "لا توجد فواتير مفتوحة",
    "billing": {
      "full": "فاتورة كاملة",
      "feeOnly": "رسوم فقط"
    },
    "failureBanner": "فشلت محاولة دفع لفاتورة <num>{{number}}</num>{{reason}}. الفاتورة ما زالت مفتوحة."
  }
}
